import {createApi} from '@reduxjs/toolkit/query/react';
import {customAxiosBaseQuery} from '../API/customAxiosBaseQuery';
import {newsAPI} from '../API/api';
import {BaseResponseType} from '../types/TypesStore';
import {
	infoType,
	OneNewsTypes,
	RequestDataTypes,
	NewsViewType,
	BannerImagesType,
} from '../types/TypesNews';

export const newsApi = createApi({
	reducerPath: 'newsApi',
	baseQuery: customAxiosBaseQuery,
	tagTypes: [
		'news-list',
		'news-view',
		'tags',
		'categories',
		'fixed-list',
		'banners',
	],
	endpoints: (builder) => ({
		getNewsList: builder.query<
			BaseResponseType & {msg_list: OneNewsTypes[] | null},
			RequestDataTypes
		>({
			query: (data) => ({
				func: newsAPI.getNewsList,
				args: [data],
			}),
			providesTags: ['news-list'],
		}),
		getTagsList: builder.query<
			BaseResponseType & {msg_tags: infoType[] | null},
			void
		>({
			query: () => ({
				func: newsAPI.getTagsList,
				args: [],
			}),
			providesTags: ['tags'],
		}),
		getCategoriesList: builder.query<
			BaseResponseType & {msg_categories: infoType[] | null},
			void
		>({
			query: () => ({
				func: newsAPI.getCategoryList,
				args: [],
			}),
			providesTags: ['categories'],
		}),
		getFixedList: builder.query<
			BaseResponseType & {fixed: OneNewsTypes[] | null},
			void
		>({
			query: () => ({
				func: newsAPI.getFixedList,
				args: [],
			}),
			providesTags: ['fixed-list'],
		}),
		getNewsView: builder.query<BaseResponseType & NewsViewType, number>({
			query: (id) => ({
				func: newsAPI.getNewsView,
				args: [id],
			}),
			providesTags: ['news-view'],
		}),
		getBannerImages: builder.query<
			BaseResponseType & {images: BannerImagesType[]},
			string
		>({
			query: (type) => ({
				func: newsAPI.getBannerImages,
				args: [type],
			}),
			providesTags: ['banners'],
		}),
	}),
});

export const {
	useGetNewsListQuery,
	useGetTagsListQuery,
	useGetCategoriesListQuery,
	useGetFixedListQuery,
	useGetNewsViewQuery,
	useGetBannerImagesQuery,
} = newsApi;
